import { makeStyles } from '@material-ui/core/styles'
const StylesWithMaterialUi = makeStyles((theme) => ({
  gridRoot: {
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(3),
      flexGrow: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(3),
      flexGrow: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
  },

  gridItem: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  gridItemDateRanger: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '90%',
  },
  input: {
    fontFamily: 'Poppins',
    fontSize: '14px',
  },
  text: {
    fontWeight: 'bold',
    fontFamily: 'Comfortaa',
    fontSize: '15px',
  },
  btn: {
    fontSize: '12px',
    fontWeight: '300',
    fontFamily: 'Comfortaa',
    textTransform: 'none',
    width: '110px',
    height: 'auto',
  },
  gridItemBtn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}))
export default StylesWithMaterialUi
